import React, { useState } from 'react';

function JobSearchStep({ data, updateData, nextStep }) {
  const [errors, setErrors] = useState({});

  const employmentOptions = [
    { value: 'employed', label: 'Currently Employed', icon: '💼' },
    { value: 'unemployed', label: 'Unemployed', icon: '🔍' },
    { value: 'student', label: 'Student', icon: '🎓' },
    { value: 'freelance', label: 'Freelancer/Consultant', icon: '💻' },
    { value: 'career-change', label: 'Career Change', icon: '🔄' }
  ];

  const jobSearchOptions = [
    { value: 'actively-searching', label: 'Actively Searching', description: 'Applying to jobs daily' },
    { value: 'passively-looking', label: 'Passively Looking', description: 'Open to opportunities' },
    { value: 'planning-to-search', label: 'Planning to Search', description: 'Will start searching soon' },
    { value: 'not-searching', label: 'Not Currently Searching', description: 'Just exploring options' }
  ];

  const handleSelection = (field, value) => {
    updateData({ [field]: value });
    // Clear error when user makes selection
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validateAndNext = () => {
    const newErrors = {};
    
    if (!data.employmentStatus) {
      newErrors.employmentStatus = 'Please select your employment status';
    }
    
    if (!data.jobSearchStatus) {
      newErrors.jobSearchStatus = 'Please select your job search status';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    nextStep();
  };

  return (
    <div className="bg-white bg-opacity-5 rounded-lg border border-gray-200 border-opacity-20 p-8 md:p-12">
      {/* Header */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-white mb-3">
          Tell us about your <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">job search</span>
        </h2>
        <p className="text-gray-400">
          This helps us tailor Elena's recommendations for you
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-8">
        {/* Employment Status */}
        <div>
          <label className="block text-lg font-medium text-gray-300 mb-4">
            What's your current employment status? *
          </label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {employmentOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => handleSelection('employmentStatus', option.value)}
                className={`p-4 rounded-lg border-2 transition-all duration-200 text-left ${
                  data.employmentStatus === option.value
                    ? 'border-blue-500 bg-blue-500 bg-opacity-20 text-white'
                    : 'border-gray-600 bg-gray-700 bg-opacity-30 text-gray-300 hover:border-gray-500 hover:bg-opacity-40'
                }`}
              >
                <div className="flex items-center">
                  <span className="text-xl mr-3">{option.icon}</span>
                  <span className="font-medium">{option.label}</span>
                </div>
              </button>
            ))}
          </div>
          {errors.employmentStatus && (
            <p className="text-red-400 text-sm mt-2">{errors.employmentStatus}</p>
          )}
        </div>

        {/* Job Search Status */}
        <div>
          <label className="block text-lg font-medium text-gray-300 mb-4">
            How actively are you job searching? *
          </label>
          <div className="space-y-3">
            {jobSearchOptions.map((option) => (
              <button
                key={option.value}
                onClick={() => handleSelection('jobSearchStatus', option.value)}
                className={`w-full p-4 rounded-lg border-2 transition-all duration-200 text-left ${
                  data.jobSearchStatus === option.value
                    ? 'border-purple-500 bg-purple-500 bg-opacity-20 text-white'
                    : 'border-gray-600 bg-gray-700 bg-opacity-30 text-gray-300 hover:border-gray-500 hover:bg-opacity-40'
                }`}
              >
                <div className="flex justify-between items-center">
                  <div>
                    <div className="font-medium text-white">{option.label}</div>
                    <div className="text-sm text-gray-400 mt-1">{option.description}</div>
                  </div>
                  {data.jobSearchStatus === option.value && (
                    <svg className="w-5 h-5 text-purple-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              </button>
            ))}
          </div>
          {errors.jobSearchStatus && (
            <p className="text-red-400 text-sm mt-2">{errors.jobSearchStatus}</p>
          )}
        </div>

        {/* Continue Button */}
        <div className="pt-4">
          <button
            onClick={validateAndNext}
            className="w-full px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-medium rounded-lg hover:from-blue-600 hover:to-purple-600 transition-all duration-200"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

export default JobSearchStep; 